import { render, staticRenderFns } from "./ModalDisclaimer.vue?vue&type=template&id=5d8bc3d6&"
import script from "./ModalDisclaimer.vue?vue&type=script&lang=js&"
export * from "./ModalDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./ModalDisclaimer.vue?vue&type=style&index=0&id=5d8bc3d6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports